import React, { useContext, useState, useEffect } from 'react';
import { ArrowLeft, CreditCard, Banknote, User } from 'lucide-react';
import { CartContext } from '../CartContext';
import InputField from './InputField';

export default function OrderPage({ setPage, onCompleteOrder }) {
  const { cart, totalPrice, itemCount } = useContext(CartContext);
  const [paymentMethod, setPaymentMethod] = useState('bank');
  const [amountPaid, setAmountPaid] = useState(totalPrice.toFixed(2));
  const [refNo, setRefNo] = useState('');
  const API_BASE_URL = window._config?.apiBaseUrl || '';
   const DATABASE_KEY = window._config?.databaseKey || '';
  const canConfirm = amountPaid.trim() !== '' && refNo.trim() !== '';

  const [bankInfo, setBankInfo] = useState({
    bankName: '',
    accno: '',
    branch: '',
    ifsc: '',
  });

  useEffect(() => {
  setAmountPaid(totalPrice.toFixed(2));
}, [totalPrice]);

  useEffect(() => {
    setBankInfo({
      bankName: localStorage.getItem('bankName') || '',
      accno: localStorage.getItem('accno') || '',
      branch: localStorage.getItem('branch') || '',
      ifsc: localStorage.getItem('ifscode') || '',
    });
  }, []);

  const handlePlaceOrder = async () => {
    // if (!canConfirm) return;

    const paymentDetails = {
      method: paymentMethod,
      amount: 0,
      reference: refNo,
    };

    try {
      const Podate = new Date().toISOString();
      const OrderTotal = totalPrice;
      const UserName = localStorage.getItem('userName') || 'guest';
      const SessId = localStorage.getItem('sessionId') || 'defaultSession';
      const Vname = localStorage.getItem('vname') || 'Vendor ABC';
      const Vid = parseInt(sessionStorage.getItem('vid')) || 0;
      const VCode = localStorage.getItem('vcode') || 'V001';
      const NewPoId = 0;
      const DeliveryDate = localStorage.getItem('deliveryDate') || new Date().toISOString().split('T')[0];
      const Address = localStorage.getItem('deliveryAddress') || '';

      const Items = cart.map((item, index) => ({
        Slno: index + 1,
        Itemid: item.id,
        Partno: item.partno || '',
        Qty: item.quantity,
        Rate: 0,
        Amount: 0,
        Partdesc: item.name || '',
      }));

      const payload = {
        Podate,
        OrderTotal:0,
        UserName,
        SessId,
        Vid,
        Vname,
        VCode,
        NewPoId,
        DeliveryDate,
        Address,
        AmountPaid: 0,
        ReferenceNo: refNo,
        Paymode: "",
        Items,
        databaseKey: window._config?.databaseKey || '',
      };

     const response = await fetch(
  `${API_BASE_URL}/OnlineCreateSimplePOAPI?databaseKey=${encodeURIComponent(DATABASE_KEY)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`API Error: ${response.status}`);

      const result = await response.json();
      //  console.log('Order placed successfully:', result);

      const poid = result?.onlinePoItemBOAPIjs?.Table?.[0]?.Poid;

      if (poid) {
        localStorage.setItem('poid', poid.toString());
        //   console.log('Stored Poid:', poid);
      } else {
        console.warn('Poid not found in response');
      }

      localStorage.setItem('paymode', paymentMethod === 'upi' ? 'UPI' : 'Bank');
      localStorage.setItem('amountPaid', amountPaid);
      localStorage.setItem('referenceNo', refNo);
      localStorage.setItem('orderCart', JSON.stringify(cart));
      localStorage.setItem('orderTotal', totalPrice.toFixed(2));


      onCompleteOrder(paymentDetails);
    } catch (err) {
      alert('Failed to place order: ' + err.message);
      console.error(err);
    }
  };

  return (
  <div className="min-h-screen bg-gradient-to-br 
                from-rose-50 via-white to-teal-50 
                px-4 py-6">
    <div className="w-full max-w-6xl mx-auto 
                bg-white rounded-3xl shadow-2xl 
                p-4 sm:p-6 
                grid grid-cols-1 lg:grid-cols-2 
                gap-6">

      {/* LEFT SIDE */}
     <div className="flex flex-col">

        {/* Back */}
        <button
          onClick={() => setPage('cart')}
          className="flex items-center gap-2 text-teal-600 hover:text-teal-800 font-medium mb-3"
        >
          <ArrowLeft size={18} />
          Back
        </button>

        <h1 className="text-2xl font-bold text-gray-800 mb-3">
          Order Summary
        </h1>

        {/* Items Scrollable */}
        <div className="max-h-60 sm:max-h-80 lg:max-h-[400px] 
                overflow-y-auto pr-2 
                space-y-3 border rounded-xl p-4 bg-gray-50">
         {cart.map(item => (
  <div
    key={item.id}
    className="flex justify-between items-center bg-white px-3 py-2 rounded-lg shadow-sm"
  >
    <div>
      <p className="font-medium text-gray-800 text-sm">
        {item.name}
      </p>
    </div>

    <p className="font-semibold text-gray-800 text-sm">
      Qty: {item.quantity}
    </p>
  </div>
))}
        </div>

        {/* Totals */}
        <div className="mt-4 border-t pt-3 space-y-2">
          <div className="mt-4 border-t pt-3">
  <div className="flex justify-between text-lg font-bold">
    <span>Total Quantity</span>
    <span className="text-teal-600">
      {cart.reduce((sum, item) => sum + item.quantity, 0)}
    </span>
  </div>
</div>
          {/* <div className="flex justify-between text-lg font-bold">
            <span>Total</span>
            <span className="text-teal-600">
              ₹{totalPrice.toFixed(2)}
            </span>
          </div> */}
        </div>
      </div>

      {/* RIGHT SIDE - PAYMENT */}
      <div className="flex flex-col space-y-4">

        {/* <h2 className="text-xl font-bold text-gray-800 mb-4">
          Payment
        </h2> */}

        {/* Payment Toggle */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          {/* <button
            onClick={() => setPaymentMethod('upi')}
            className={`p-3 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition ${
              paymentMethod === 'upi'
                ? 'bg-teal-600 text-white shadow-lg'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            <CreditCard size={18} />
            UPI
          </button> */}

          {/* <button
            onClick={() => setPaymentMethod('bank')}
            className={`p-3 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition ${
              paymentMethod === 'bank'
                ? 'bg-teal-600 text-white shadow-lg'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            <Banknote size={18} />
            Bank
          </button> */}
        </div>

        {/* Payment Content */}
        <div className="flex-1 overflow-y-auto">

           {/* {paymentMethod === 'upi' && (
            <div className="text-center bg-gray-50 p-3 rounded-lg border">
              <p className="mb-4 text-gray-600">Scan the QR Code to pay</p>
              {(() => {
                const baseQr = localStorage.getItem('qrcodelink') || '';
                const updatedQr = baseQr.replace(/am=\d+(\.\d+)?/, `am=${totalPrice.toFixed(2)}`);
                const qrEncoded = encodeURIComponent(updatedQr);
                return (
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?data=${qrEncoded}&size=200x200`}
                    alt="QR Code"
                    className="mx-auto rounded-lg shadow-md"
                  />
                );
              })()}
            </div>
          )} */}

          {/* {paymentMethod === 'bank' && (
            <div className="bg-gray-50 p-4 rounded-xl border mb-4 text-sm space-y-1">
              <p><strong>Bank:</strong> {bankInfo.bankName || 'N/A'}</p>
              <p><strong>A/C:</strong> {bankInfo.accno || 'N/A'}</p>
              <p><strong>Branch:</strong> {bankInfo.branch || 'N/A'}</p>
              <p><strong>IFSC:</strong> {bankInfo.ifsc || 'N/A'}</p>
            </div>
          )} */}

          <div className="space-y-3">
            {/* <InputField
              icon={<User />}
              name="amountPaid"
              type="number"
              placeholder="Amount Paid"
              value={amountPaid}
              onChange={(e) => setAmountPaid(e.target.value)}
              required
            /> */}

            <InputField
              icon={<User />}
              name="refNo"
              type="text"
              placeholder="Reference No."
              value={refNo}
              onChange={(e) => setRefNo(e.target.value)}
              required
            />
          </div>
        </div>

        {/* Confirm Button Always Visible */}
        <div className="mt-4">
          <div className="mt-4">
  <button
    onClick={handlePlaceOrder}
    className="w-full py-3 rounded-xl font-bold transition shadow-lg bg-gradient-to-r from-teal-500 to-emerald-600 text-white hover:from-teal-600 hover:to-emerald-700"
  >
    Confirm Order
  </button>
</div>
          {/* <button
            onClick={handlePlaceOrder}
            disabled={!canConfirm}
            className={`w-full py-3 rounded-xl font-bold transition shadow-lg ${
              canConfirm
                ? 'bg-gradient-to-r from-teal-500 to-emerald-600 text-white hover:from-teal-600 hover:to-emerald-700'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Confirm Order
          </button> */}
        </div>

      </div>
    </div>
  </div>
);
}
